// 调证协查页面翻译
export default {
  title: "调证协查",
  tips: {
    investigationInfo: "调证信息",
    investigationLimit:
      "（每次调证建议查询信息不建议超过10条，以免调证结果返回时间过长）",
  },
  form: {
    platformType: "平台类型（必填）",
    operationType: "操作类型（必填）",
    selectPlatform: "选择平台（必填）",
    priority: "调证优先级",
    addressInfo: "地址信息",
    addressVerify: "地址校对",
    withdrawHash: "提币哈希",
    hashVerify: "哈希校对",
    identityInfo: "身份信息",
    identityVerify: "身份校对",
    remark: "备注",
    relatedCase: "关联案件",
  },
  placeholders: {
    selectPlatformType: "请选择平台类型",
    selectOperationType: "请选择操作类型",
    selectPlatform: "请选择平台",
    selectInstitution: "请选择机构",
    selectChain: "请输入链",
    selectCase: "请选择案件",
    addressInfo: `请填写已掌握的交易地址，多个地址换行分割，最大不超过50个地址
示例：
TNUC9Qb1rRpS5CbWLmNMxXBjyFoydXjWFR
TSUUVjysXV8YqHytSNjfkNXnnB49QDvZpx`,
    hashInfo: `请填写已掌握的提币哈希，多个哈希换行分割，最大不超过50条提币哈希
示例：
c45ee90b9e5d850ac799740d6137b5b9f52e26e51ead132e459f5fc06fc89b73
b556473f9030cf2c1bb176f5aad11786419c41aff865a710b0a0d20976617df2`,
    identityInfo: `请填写已掌握的身份信息，多个身份信息换行分割，最大不超过50条身份信息
示例：
Binance-xxxxxx
Binance-xxxxxx
`,
    remark: "请输入备注，如调证原因等…",
    selectRelatedCase: "请选择关联案件",
  },
  buttons: {
    addressRecognize: "地址识别",
    hashRecognize: "哈希识别",
    identityRecognize: "身份识别",
    generateDocument: "生成调证文书",
    batchImport: "批量导入",
    downloadTemplate: "模版下载",
  },
  messages: {
    chainRequired: "链必填！",
    addSuccess: "新增成功",
    uploadExcelOnly: "只能上传excel的文件",
    tagNotSupport: "该标签暂不支持批量上传",
  },
  validation: {
    institutionTypeRequired: "机构类型为必填项",
    operationTypeRequired: "操作类型为必填项",
    priorityRequired: "优先级为必填项",
    platformRequired: "机构为必填项",
    chainRequired: "链为必填项",
  },
  documentfile: {
    title: "文书预览",
    buttons: {
      download: "下载调证文书",
      previous: "上一步",
    },
    preview: "调证文书预览",
    loading: "拼命加载中",
    info: {
      email: "调证邮箱：",
      emailTitle: "建议调证邮箱标题：",
      emailAttachment: "调证邮件附件材料：",
      notes: "其他注意事项：",
      none: "暂无",
    },
    notesList: {
      note1: "1.去中心化钱包服务商的用户资产无法冻结",
      note2:
        "2.调证的数据范围时间范围尽量明确，建议是调取所有时长内的信息和操作记录",
      note3:
        "3.建议向平台明确调取的数据材料返回格式要为Excel，严禁图片和PDF格式",
      note4: "4.需要要求平台加盖公司电子公章，以便后续做证据固定使用",
      note5:
        "5.针对海外交易所，为提升调证的成功率，建议使用gov.cn等政府邮箱发送调证",
    },
    downloadFilename: "案件调取证据通知书",
  },
};
